module.exports = __webpack_public_path__ + "static/media/logo.e68d60f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 169
// module chunks = 0